import React from 'react';
import ContentLoader from 'react-content-loader';

type SkeletonSelectedSafeCardProps = {
  isInvite: boolean;
};

export const SkeletonSelectedSafeCard: React.FC<SkeletonSelectedSafeCardProps> = ({ isInvite }) => {
  return (
    <ContentLoader
      speed={2}
      height="100%"
      width="100%"
      backgroundColor="#FFFFFF1A"
      foregroundColor="#43464D"
      className="p-16 rounded-[12px] w-full bg-[#1F2023]"
    >
      <rect x="0" y="0" rx="20" ry="20" width="40" height="40" />
      <rect x="48" y="4" rx="4" ry="4" width="90" height="16" />
      <rect x="48" y="24" rx="4" ry="4" width="50" height="16" />
      {isInvite ? (
        <>
          <rect x="0" y="62" rx="4" ry="4" width="95" height="36" />
          <rect x="98" y="62" rx="4" ry="4" width="95" height="36" />
          <rect x="0" y="104" rx="6" ry="4" width="100%" height="32" />
          <rect x="0" y="160" rx="6" ry="4" width="100%" height="1" />
          <rect x="20%" y="170" rx="6" ry="4" width="60%" height="16" />
        </>
      ) : (
        <>
          <rect x="0" y="60" rx="4" ry="4" width="36" height="36" />
          <rect x="40" y="60" rx="4" ry="4" width="36" height="36" />
          <rect x="80" y="60" rx="4" ry="4" width="36" height="36" />
          <rect x="120" y="60" rx="4" ry="4" width="72" height="36" />
        </>
      )}
    </ContentLoader>
  );
};
